import React from "react";
import themePropTypes from "../theme-prop-types";
import Text from "./text";
import HorizontalRule from "./horizontal-rule";

const Message = ({ subject, latestMessage, viewed }) => (
  <>
    <div
      className={`message-web-sdk ${viewed ? "" : "message-unread-web-sdk"}`}
    >
      {subject}
    </div>
    <Text label={latestMessage} />
    <HorizontalRule />
  </>
);

Message.propTypes = themePropTypes.message;

export default Message;
